import { defineStore } from "pinia";
import Network from "~/utils/network";

const urls = {};

export const useCountryStore = defineStore("country", {
  state: () => ({
    country: {},
  }),
  actions: {
    load(country) {
      this.country = country;
    },
  },
  getters: {
    countryId: (state) => state.country.id,
    locale: (state) => state.country.languageIso,
    shortLocale: (state) => state.country.languageIso.split("-")[0],
    currency: (state) => state.country.currencyIso,
    messengerPageId: (state) => state.country.messengerPageId,
    messengerLocale: (state) => state.country.languageIso.replace("-", "_"),
    phoneMask: (state) => state.country.phoneFormat,
    phoneCountryCode: (state) => state.country.phoneCountryCode,
    phoneLength: (state) => state.country.phoneLength,
    phonePrefixes: (state) => state.country.phonePrefixes ?? [],
    flag: (state) => state.country.flag,
    contactPhone: (state) => state.country.contactPhone,
    psd2Type: (state) => state.country.syncType,
    businessSyncType: (state) => state.country.businessSyncType,
    lastNameFirst: (state) => state.country.lastNameFirst,
  },
});
